import { events } from '../../constants/dataLayer';
import { pushData, pushEvent } from '../utils/dataLayer';
import { API_ERROR, BLOCK_ERROR_MSG, BLOCK_MICROPHONE, INACTIVITY_TEXT, LISTENING, USER_INACTIVITY, VOICE_SEARCH_PLACEHOLDER } from '../../constants/voiceSearch';


export const getVoiceText = (status: number) => {
  switch (status) {
    case LISTENING:
      return VOICE_SEARCH_PLACEHOLDER;
    case USER_INACTIVITY:
    case API_ERROR:
        return INACTIVITY_TEXT;
    case BLOCK_MICROPHONE:
      return BLOCK_ERROR_MSG;
    default:
      return '';
  }
};

export const trackVoiceSearch = (fromHeader = false) => {
  const event = (fromHeader) ? (events.VOICE_SEARCH_CLICK) : (events.VOICE_SEARCH_TRY_AGAIN);
  pushEvent(event);
};

export const trackVoiceSearchSupport = (support: boolean) => {
  const data = {
    voiceSearchSupport: (support) ? 'true' : 'false',
  };
  pushData(data);
};
